export const EPP_PORTAL_CONSTANTS = {
   EPP_TEMPLATE :'EPP_Template',
   EPP_SUBMISSION_DATA :'EPP'
};